import React from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';
import { getIn } from 'formik';
const { Option } = Select;

const operators = ['+', '-'];

function OperatorField(props) {
  const { field, form, label, ...restProps } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const { name, value } = field;
  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <Select
        mode="single"
        placeholder={label}
        onChange={val => {
          form.setFieldValue(name, val);
        }}
        value={value}
        defaultValue="+"
        {...restProps}
      >
        {operators.map(opereatorItem => (
          <Option key={opereatorItem}>{opereatorItem}</Option>
        ))}
      </Select>
    </Form.Item>
  );
}
OperatorField.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  options: PropTypes.array,
  label: PropTypes.string
};

OperatorField.defaultProps = {
  defaultValue: []
};
export default OperatorField;
